import { NgModule } from '@angular/core';
import { LoginButtonComponent } from './components/login-button/login-button.component';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SharedPlatformModule } from '../shared-platform/shared-platform.module';

@NgModule({
    imports: [
        CommonModule,
        AngularSvgIconModule,
        SharedPlatformModule,
        LoginButtonComponent,
    ],
    exports: [LoginButtonComponent],
    schemas: [],
})
export class AuthenticationModule {
    constructor() {}
}
